import { defineComponent as _defineComponent } from 'vue'
import FileForDownload from '~/components/ui/FileForDownload.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockDownloadableFiles',
  props: {
  displayOptions: {
    type: Array,
    default: () => [],
  },
  title: String,
  catchphrase: String,
  files: {
    type: Array,
    default: () => [],
  },
  divider: Boolean,
  link: String,
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, FileForDownload, AzIcon }
}

})